import React, { useContext } from 'react';
import Box from '@/internals/Box';
import { ModalContext } from './ModalContext';
import { useStyles } from '@/internals/hooks';
import { forwardRef } from '@/internals/utils';
import type { ComponentProps } from '@/internals/utils';

export type ModalTitleProps = ComponentProps;

const ModalTitle = forwardRef<'h4', ComponentProps>((props, ref) => {
  const { as = 'h4', classPrefix = 'modal-title', className, role, ...rest } = props;
  const { withPrefix, merge } = useStyles(classPrefix);
  const classes = merge(className, withPrefix());

  const context = useContext(ModalContext);

  return (
    <Box
      as={as}
      id={context ? `${context.dialogId}-title` : undefined}
      {...rest}
      role={role}
      ref={ref}
      className={classes}
    />
  );
});

ModalTitle.displayName = 'Modal.Title';

export default ModalTitle;
